import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const Edit = lazy(() => import('./Edit/WorkflowEditPage'));
const Debug = lazy(() => import('./Debug/WorkflowDebugPage'));
const Invoke = lazy(() => import('./Invoke/WorkflowInvokePage'));

export const WorkflowsRoutes = () => {
    return (
        <Routes>
            <Route path="/workflows/edit/:name/:version" element={<Edit />} />
            <Route path="/workflows/invoke" element={<Invoke key={Date.now()} />} />

            <Route path="/debug/workflow/:name/:version/:revision?" element={<Debug />} />
            <Route path="/debug/report/:workflowType/:reportId" element={<Debug />} />

            <Route path="*" element={null} />
        </Routes>
    );
};
